import { lazy } from "react";

export const Navbar = lazy(() => import("./Navbar"));
